//import axios from "axios";
//import { Api } from "services/Api/Api";
//import { IDigitalWalletPaymentRequest, IDigitalWallet } from "./walletTypes";

export const AuthorizeMerchantApple = async (validationURL: string) => {//TODO: IMPLEMENTAR PRODUÇÃO
	
	//const response = await fetch(process.env.REACT_APP_API_PAYMENT_URL + '/wallets/apple/authorize-merchant', {

	const urlDEV = 'https://payment-gateway-api-dev.meep.cloud/api/wallets/apple/authorize-merchant';
	const urlPROD = process.env.REACT_APP_API_PAYMENT_URL + '/wallets/apple/authorize-merchant';

	const isDev = window.location.href.toLowerCase().includes("mepay-dev.meep.cloud");

	const response = await fetch(isDev ? urlDEV : urlPROD, {
	  method: 'POST',
	  headers: {
		'accept': 'application/json',
		'Content-Type': 'application/json',
		//'Ocp-Apim-Subscription-Key': process.env.REACT_APP_PAYMENT_SUBSCRIPTION_KEY || ""
	  },
	  body: JSON.stringify({
		validationURL
	  })
	});
  
	const data = await response.json();
	//console.log("response", data);
  
	if (!response.ok) {
	  throw new Error(`Request failed with status ${response.status}`);
	} else {
	  return data.value;
	}
  };
  
  //export const PostDigitalWalletPayment = async (data: IDigitalWalletPaymentRequest, front: boolean = false): Promise<IDigitalWallet> => {
  
  //  if (front) {
  //    const response = await PostDigitalWalletPaymentCielo(data);
  //    return {
  //      value: response.data,
  //      status: response.status,
  //      isSuccess: response.data.isSuccess,
  //      successMessage: response.data.successMessage,
  //      correlationId: response.data.correlationId,
  //      errors: response.data.errors,
  //      validationErrors: response.data.validationErrors,
  //    };
  //  }
  
  //  const response = await Api().post<IDigitalWallet>("/Payments/wallet", data, {
  //    headers: {
  //      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_PAYMENT_SUBSCRIPTION_KEY || ""
  //    },
  //  });
  //  //const response = await PostDigitalWalletPaymentCielo(data);
  //  return response.data as IDigitalWallet;
  //};
  
  //export const PostDigitalWalletPaymentCielo = async (data: IDigitalWalletPaymentRequest) => {
  //  const randomId = Math.floor(Math.random() * 10000000000).toString();
  //  console.log("randomId", randomId);
  //  const response = await axios.post<IDigitalWallet>("https://api.cieloecommerce.cielo.com.br/1/sales", {
  
  //    //...data,
  //    "MerchantOrderId": randomId,
  //    "Customer": {
  //      "Name": data.payer.name,
  //      "Identity": data.payer.document,
  //      "IdentityType": "CPF"
  //    },
  //    "Payment": {
  //      "Type": "CreditCard",
  //      "Amount": Math.round(data.amount * 100),
  //      "Currency": data.currency,
  //      "Installments": 1,
  //      "SoftDescriptor": data.softDescriptor,
  //      "Capture": true,
  //      "Wallet": {
  //        "Type": "ApplePay",
  //        "WalletKey": data.wallet.walletKey,
  //        "AdditionalData": {
  //          "EphemeralPublicKey": data.wallet.additionalData?.ephemeralPublicKey,
  //          "TransactionId": data.wallet.additionalData?.transactionId,
  //          "PublicKeyHash": data.wallet.additionalData?.publicKeyHash,
  //        }
  //      }
  //    }
  //  }, {
  
  //    headers: {
  //      //"Ocp-Apim-Subscription-Key": import.meta.env.VITE_PAYMENT_SUBSCRIPTION_KEY,
  //      "MerchantId": 'aeaa7cb4-b100-4d75-865a-7f99aed898d9',
  //      "MerchantKey": 'oZ4YF8jgKMKJa2kWZrSoQ6oseUuo2thvgadU1LAf'
  //    }
  //  });
  //  return response;
  //};
  
  